export const GET_TAX_DETAIL_BEGIN = 'GET_TAX_DETAIL_BEGIN';
export const GET_TAX_DETAIL_SUCCESS = 'GET_TAX_DETAIL_SUCCESS';
export const GET_TAX_DETAIL_FAIL = 'GET_TAX_DETAIL_FAIL';
